import React, { FC } from 'react';
import { HitsOfTheWeek } from '../components/mainPageBody/hitsOfTheWeekSlider/HitsOfTheWeek';
import { News } from '../components/mainPageBody/News';
import { Promotions } from '../components/mainPageBody/promotions/Promotions';
import { RecommendedProducts } from '../components/mainPageBody/recommendedProducts/RecommendedProducts';
import { BestSellers } from '../components/mainPageBody/bestsellers/BestSellers';

import styles from './MainPageBody.module.css';

type SectionNameNavigateProps = {
    sectionName: string,
    url?: string,
}

const SectionNameNavigate: FC<SectionNameNavigateProps> = ({ sectionName, url }) => {
    return (
        <div className={styles.sectionNavContainer}>
            <h2>{sectionName}</h2>
            {
                url && <a href={url} className={styles.sectionNavShowAll}>Pokaż wszystkie ❯</a>
            }
        </div>
    );
}

export const MainPageBody = () => {
    return (
        <div className={styles.mainPageBody}>
            <News />
            <SectionNameNavigate sectionName="Recomended products" />
            <RecommendedProducts />
            <hr />
            <SectionNameNavigate sectionName="Promotions" url="/promotions" />
            <Promotions />
            <hr />
            <SectionNameNavigate sectionName="Hits of the week" url="/hitsoftheweek" />
            <HitsOfTheWeek />
            <hr />
            <SectionNameNavigate sectionName="Bestsellers" url="/bestsellers" />
            <BestSellers />
            <hr />
        </div>
    );
}